// extracted by mini-css-extract-plugin
export default {"widdgetLoader":"ActorsTypes_widdgetLoader__7jS+G"};